import { useSelector, useDispatch } from "react-redux";
import { login, logout, setUser } from "../store/features/auth/authSlice";

export const useAuth = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, token, user, role } = useSelector((state) => state.auth);

  return {
    isAuthenticated,
    token,
    user,
    role,
    login: (data) => dispatch(login(data)),
    logout: () => dispatch(logout()),
    setUser: (data) => dispatch(setUser(data)),
  };
};
